/// <reference path="../interfaces/interfaces.d.ts"/>

import * as React from 'react';
import * as i18next from 'i18next';
import { withTranslation } from 'react-i18next';
import driverinfosecurity from '../../utils/DriverInfoSecurity';
import { filter } from '../../constants/filter';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Button from '@mui/material/Button';
import SearchIcon from '@mui/icons-material/Search';
import Paper from '@mui/material/Paper';

interface SearchBoxState {
    handleChange: (e: any) => void;
    searchQuery: string;
    activeFilterValue?: string;
    handleChangeFilter?: (e: any) => void;
    searchSite: (e: any) => void;
}

type Props = SearchBoxState;

class Searchbox extends React.Component<Props, {}> {
    render() {
        const isAdmin = driverinfosecurity.isAdmin();
        return (
            <Paper
                component="form"
                elevation={0}
                sx={{ bgcolor: 'primary.main', p: 2, borderRadius: 0 }}
            >
                <Box sx={{ display: 'flex', gap: 1.5, alignItems: 'center' }}>
                    <TextField
                        id="inputQuery"
                        name="query"
                        type="search"
                        size="small"
                        value={this.props.searchQuery}
                        onChange={(e: any) => this.props.handleChange(e)}
                        placeholder={driverinfosecurity.isAdmin()
                            ? i18next.t('adminsites.searchboxplaceholder')
                            : i18next.t('site.searchboxplaceholder')
                        }
                        sx={{
                            flex: isAdmin ? 5 : 9,
                            bgcolor: 'rgba(255,255,255,0.95)',
                            borderRadius: 0.5,
                            '& .MuiOutlinedInput-root': { borderRadius: 0.5 }
                        }}
                    />
                    {isAdmin && (
                        <Select
                            id="filterdropdown"
                            size="small"
                            value={this.props.activeFilterValue ?? filter[0]?.filterKey ?? ''}
                            onChange={(e: any) => this.props.handleChangeFilter ? this.props.handleChangeFilter(e) : null}
                            sx={{
                                flex: 4,
                                bgcolor: 'rgba(255,255,255,0.95)',
                                borderRadius: 0.5,
                                '& .MuiOutlinedInput-notchedOutline': { borderRadius: 0.5 }
                            }}
                        >
                            {filter.map(f => (
                                <MenuItem key={f.filterKey} value={f.filterKey}>{i18next.t(f.languageKey)}</MenuItem>
                            ))}
                        </Select>
                    )}
                    <Button
                        type="submit"
                        variant="contained"
                        color="secondary"
                        startIcon={<SearchIcon />}
                        onClick={(e: any) => this.props.searchSite(e)}
                        sx={{ flex: 3, whiteSpace: 'nowrap', height: 40 }}
                    >
                        {i18next.t('site.searchbutton')}
                    </Button>
                </Box>
            </Paper>
        );
    }
}

export default withTranslation('translations')(Searchbox);
